export const toastContainerProps = {
    autoClose: 5000,
    closeOnClick: false,
    draggable: true,
    hideProgressBar: false,
    newestOnTop: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    position: 'bottom-right',
    rtl: false,
};

export const toastProps = {};
